(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('menu-countdown')) return;
    class MenuCountdown extends HTMLElement {
      connectedCallback() {
        this.timer = this.querySelector('[data-timer]');
        this.closedMessage = this.querySelector('[data-closed]');
        this.units = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]')
        };
        this.deadline = new Date(this.dataset.expiry).getTime();
        this.render();
        this.interval = window.setInterval(() => this.render(), 1000);
      }
      disconnectedCallback() { window.clearInterval(this.interval); }
      render() {
        const remaining = this.deadline - Date.now();
        if (!Number.isFinite(this.deadline) || remaining <= 0) {
          if (this.timer) this.timer.hidden = true;
          if (this.closedMessage) this.closedMessage.hidden = false;
          window.clearInterval(this.interval);
          document.querySelectorAll("form[action*='/cart/add'] button[type='submit'], form[action*='/cart/add'] button[name='add'], .shopify-payment-button button").forEach((button) => {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          });
          return;
        }
        if (!this.units.days || !this.units.hours || !this.units.minutes || !this.units.seconds) return;
        const seconds = Math.floor(remaining / 1000);
        this.units.days.textContent = String(Math.floor(seconds / 86400)).padStart(2, '0');
        this.units.hours.textContent = String(Math.floor((seconds % 86400) / 3600)).padStart(2, '0');
        this.units.minutes.textContent = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        this.units.seconds.textContent = String(seconds % 60).padStart(2, '0');
      }
    }
    customElements.define('menu-countdown', MenuCountdown);
  })();
  } catch(e) { console.error(e); }
})();

})();
